import { useNavigate, useParams } from "react-router-dom"
import modernLogo from "../../../assets/mofoIcon.png"
import MainLayout from "../../components/layout";

export default function ErrorStatusView() {
	const navigate = useNavigate()
	const { code } = useParams()
	const status = {
		password: "Password Issues?",
		credential: "Invalid Login Credentials",
		session: "Expired Session",
	}

	const handleClick = () => {
		navigate("/login")
	}

	return (
		<MainLayout showHeader={false}>
			<div className="flex items-center justify-center bg-white px-4 text-center sm:h-[85vh] md:h-[90vh] lg:h-[92vh] xl:h-[80vh]">
				<div className="min-w-md w-full bg-white p-6 sm:p-8 md:max-w-sm">
					<div className="mb-6 flex w-full content-center items-center justify-center tracking-wide">
						<img
							id="modernLogo"
							src={modernLogo}
							alt="modern football"
							width={"130px"}
							height={"40px"}
						/>
					</div>
					<h2 className="font-SF Pro Text text-center align-middle text-[30px] font-bold leading-[140%] tracking-normal text-gray-950">
						{(status as any)[code || ""]}
					</h2>
					<div className="mt-3 h-[44px] text-center align-middle font-sans text-sm font-normal leading-[22px] tracking-normal text-gray-700">
						{"Contact "}
						<span className="text-blue-600">support@modernfootball.com</span>
						<div>{" for more information."}</div>
					</div>
					<button
						type="submit"
						onClick={handleClick}
						className="mt-3 w-full cursor-pointer rounded-md bg-blue-600 py-2 font-semibold text-white transition hover:bg-blue-700"
					>
						Back to sign in
					</button>
				</div>
			</div>
		</MainLayout>
	)
}
